import './SessionsOutline.scss'

import { useContext, useEffect, useState } from 'react'
import parse from 'html-react-parser'
import cn from 'classnames'

import SubscriptionContext from '../../common/contexts/SubscriptionContext'
import {
  isFreeCourse,
  tryGetCourseField,
  tryGetTopicDataForLessonFromCourseSteps
} from '../../common/api/Courses'
import { navigateTo } from '../../common/navigation'
import { ROUTE_PAYMENTS } from '../../common/helpers/Paths'
import { useHistory } from 'react-router-dom'

export default function SessionsOutline({
  course,
  setTopicVideo,
  setAutoplay,
  setSessions,
  autoplayActiveIndex
}) {
  const history = useHistory()

  let sessions = []
  const [flag, setFlag] = useState(true)
  const [activeIndex, setActiveIndex] = useState(null)
  const [courseIsLocked, setCourseIsLocked] = useState(true)
  const { userSubscription: subscription, userHasPremiumAccess } =
    useContext(SubscriptionContext)

  // Subscription hook
  useEffect(() => {
    // Return early if we don't have course or subscription data
    if (!course || !subscription) return
    const isFree = isFreeCourse(course)
    const isLocked = !userHasPremiumAccess && !isFree
    setCourseIsLocked(isLocked)
  }, [course, subscription, userHasPremiumAccess])

  const handleClick = topic => {
    if (courseIsLocked) {
      /* Navigate to payments route if user don't have Premium Access */
      navigateTo(ROUTE_PAYMENTS, history)
    } else {
      if (topic) {
        setTopicVideo(topic)
        setAutoplay(true)
        setActiveIndex(topic.id)
      }
    }
  }

  useEffect(() => {
    autoplayActiveIndex && setActiveIndex(autoplayActiveIndex)
  }, [autoplayActiveIndex])

  // Set topic video and sessions
  useEffect(() => {
    if (flag && sessions.length) {
      // Set first topic as active
      const topic = sessions[0]
      setTopicVideo(topic)
      setActiveIndex(topic.id)

      setSessions(sessions)
      setFlag(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessions, flag])

  return (
    <div className='position-relative'>
      {course &&
        course.sections &&
        course.sections.map(section => {
          let index = 1

          return (
            section.lessons &&
            section.lessons.map(lesson => {
              try {
                // Get topic object from steps data
                let topics = tryGetTopicDataForLessonFromCourseSteps(
                  lesson.id,
                  course.steps
                )

                // Convert topic object to array and merge with api result
                topics = Object.keys(topics).map(topicId =>
                  course.topics.find(topic => topic.id === parseInt(topicId))
                )

                return topics.map(topic => {
                  // Video details
                  const videoDuration = tryGetCourseField(
                    topic,
                    'video_duration'
                  )

                  // Add topic to sessions array
                  topic && videoDuration !== '' && sessions.push(topic)

                  return (
                    topic &&
                    videoDuration !== '' && (
                      <div
                        key={topic.id}
                        className={cn(
                          'lesson-topic cursor-pointer d-flex justify-content-between align-items-center p-2',
                          {
                            active: activeIndex === topic.id
                          }
                        )}
                        onClick={_ => handleClick(topic)}
                      >
                        <span className='lesson-topic-counter align-self-start'>
                          {index++}.
                        </span>

                        <div className='topic-title d-flex gap-2 justify-content-between align-items-center'>
                          <h5 className='lesson-topic-title mb-0 fw-normal fs-6'>
                            {topic?.clean_title && parse(topic.clean_title)}
                          </h5>

                          <span className='lesson-topic-duration text-nowrap text-muted align-self-start'>
                            {videoDuration}
                          </span>
                        </div>
                      </div>
                    )
                  )
                })
              } catch (e) {
                return <div>Error</div>
              }
            })
          )
        })}

      {/* Overlay sessions if user don't have Premium Access */}
      {courseIsLocked && course.sections?.length > 0 && (
        <div className='sessions-locked-overflow w-100 h-100 top-0 left-0 position-absolute d-flex justify-content-center align-items-center'>
          <div className='locked-overflow-content gap-2 d-flex justify-content-around align-items-start'>
            <i className='bi bi-lock'></i>
            <span>Members only</span>
          </div>
        </div>
      )}
    </div>
  )
}
